/** @format */

import angular from 'angular';

import { EditToolsComponentsModule } from './components';
import { EditToolsI18nModule } from './i18n';
import { EditToolsDialogsModule } from './dialogs';

export const EditToolsModule = angular.module('galabid-presenter.components.edit-tools', [
    EditToolsComponentsModule,
    EditToolsI18nModule,
    EditToolsDialogsModule,
]).name;
